export default __webpack_public_path__ + "media/arrow-select.2ce8f539.svg";